// 客户转化
import req from './req'

// 保存欢迎语
export function saveWelcome (welcomeMsgId, params) {
  return req.post('customer/welcome-msg/save/' + welcomeMsgId, params)
}

// 获取欢迎语详情
export function getWelcomeInfo (welcomeMsgId, params) {
  return req.get('/customer/welcome-msg/get-info/' + welcomeMsgId, params)
}

// 应用管理-获取应用开启状态
export function getAppserviceStatus (params) {
  return req.get('/appservice-statusget', params)
}

// 应用管理-设置应用开启状态
export function saveAppserviceStatus (params) {
  return req.post('/appservice-statussave', params)
}

// 查看默认佣金规则
export function getDefaultSetting (params) {
  return req.get('/commission/default-setting-get', params)
}

// 保存默认佣金规则
export function saveDefaultSetting (params) {
  return req.post('/commission/default-setting-save', params)
}

// 查看商品拥挤配置列表
export function getCommissionList (params) {
  return req.get('/commission/rel-item-list', params)
}

// 查看导购佣金详情
export function getCommissionDetail (salesperonId, params) {
  return req.get('/commission/detail/' + salesperonId, params)
}

// 查看佣金规则详情
export function getRuleByMonth (params) {
  return req.get('/commission/rule-search-bymonth', params)
}

// 清除商品拥挤配置列表
export function cleanCommissionList (params) {
  return req.post('/commission/rel-item-clean', params)
}
